import apiClient from './client';

export interface Department {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDepartmentRequest {
  name: string;
  description?: string;
}

export interface UpdateDepartmentRequest {
  name?: string;
  description?: string;
  isActive?: boolean;
}

export interface DepartmentWithDeviceCount extends Department {
  deviceCount: number;
  pcCount: number;
}

export const departmentsApi = {
  getAll: async (): Promise<Department[]> => {
    const response = await apiClient.get('/departments');
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },

  getById: async (id: string): Promise<Department> => {
    const response = await apiClient.get(`/departments/${id}`);
    return { ...response.data, id: response.data._id };
  },

  create: async (data: CreateDepartmentRequest): Promise<Department> => {
    const response = await apiClient.post('/departments', data);
    return { ...response.data, id: response.data._id };
  },

  update: async (id: string, data: UpdateDepartmentRequest): Promise<Department> => {
    const response = await apiClient.put(`/departments/${id}`, data);
    return { ...response.data, id: response.data._id };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/departments/${id}`);
  },

  getAllWithDeviceCounts: async (): Promise<DepartmentWithDeviceCount[]> => {
    const response = await apiClient.get('/departments/with-device-counts');
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },
};
